export default __webpack_public_path__ + "static/media/section1-bg-h5.d0a711f0.png";